import Validation from '@core/logic/Validation'
import CKA from '@master/model/kyc-form/CKA'

export default class SharedCKAValidation extends Validation {
  validate (cka: CKA, belongsTo: string) {
    this.belongsTo = belongsTo
    const { getMessages, ADD } = this.validator()
    ADD(() => {
      if (cka.ckaCompleted === null || typeof cka.ckaCompleted === 'undefined') {
        return 'Client must select to complete or not to complete CKA.'
      }
      return null
    }, ['Customer Knowledge Assessment'], ['ckaCompleted'])

    return getMessages()
  }
}
